import React from 'react';
import ImgEmpty from '../../assets/Fail.png';
import DarkLogo from '../../assets/LightLogo.svg';
import LightLogo from '../../assets/DarkLogo.svg';
import Button from 'Components/Button/Button';
import { useHistory } from 'react-router-dom';

const InvalidResetPasswordPage = () => {
  const history = useHistory();

  return (
    <div className={'login-page__wrap'}>
      <div className="login-page__error">
        <strong className="login-page__logo">
          <img className="login-page__logo-img" src={JSON.parse(localStorage.getItem('nightMode')) ? DarkLogo  : LightLogo} alt="anvileight" />
        </strong>
        <img className="login-page__fail-img" src={ImgEmpty} alt="failure_image" />
        <h4 className="login-page__main-message">Link is no longer valid</h4>
        <span className="login-page__secondary-message">
          This can happen if your activation link expired or the URL is incorrect
        </span>
        <Button text="Back to login page" onClick={() => history.replace('/login/employee/')} />
      </div>
    </div>
  );
};

export default InvalidResetPasswordPage;
